/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-08 17:18:50
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-08-12 20:10:00
 * @FilePath: /partner.chaoyongtuan.com/src/modules/sample/apply/rules/dataMap.js
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
 */
import { PLATFORM_DY, PLATFORM_KS, PLATFORM_SP } from '@/utils/dataMap';
export const confs = {
	[PLATFORM_DY.value]: {
		sale_amount: '月橱窗销售额',
		sales: '月橱窗销量',
	},
	[PLATFORM_KS.value]: {
		sale_amount: '月销售额',
		sales: '月订单量',
	},
	[PLATFORM_SP.value]: {
		sale_amount: '月销售额',
		sales: '月订单量',
	},
};
